import React, { Component } from "react";
import { propertyUtil } from "views/Pma/PropertyUtil";

class QVFourCoverPageInfo extends Component {
  getDesignationStyle = (agentDesignation) => {
    const { isMemberOfTeam, listgenUserID } = this.props.agentData;
    if (listgenUserID === "103667") {
      return "agent-designation-13";
    } else if (listgenUserID === "110007") {
      return "no-agent-designation";
    } else if (
      agentDesignation &&
      agentDesignation.length >= 35 &&
      agentDesignation.length < 48
    ) {
      return "smaller-agent-designation";
    } else if (agentDesignation && agentDesignation.length >= 48) {
      if (isMemberOfTeam) {
        return "xxs-agent-designation";
      } else {
        return "xs-agent-designation";
      }
    } else {
      return "";
    }
  };
  phoneCircleDivider = (num = "", nameLength, useHyphens, alwaysShow) => {
    const { listgenUserID } = this.props.agentData;
    let showPhoneNumber = true;
    if (listgenUserID === "104519") {
      showPhoneNumber = alwaysShow === true;
    }
    if (!showPhoneNumber) {
      return null;
    }
    // Validate and sanitize the phone number

    const phoneStr = String(num || "").replace(/\D/g, ""); // Convert to string and remove non-digits

    // Return empty div if phone number is too short
    if (phoneStr.length < 10) {
      return (
        <div className={`phone-num-row ${nameLength > 14 ? "small" : ""}`}>
          {phoneStr}
        </div>
      );
    }

    if (useHyphens) {
      return (
        <div className={`phone-num-row ${nameLength > 14 ? "small" : ""}`}>
          {phoneStr.slice(0, 3)}-{phoneStr.slice(3, 6)}-{phoneStr.slice(6)}
        </div>
      );
    } else {
      return (
        <div className={`phone-num-row ${nameLength > 14 ? "small" : ""}`}>
          {phoneStr.slice(0, 3)}
          <div className="phone-circle-divider" />
          {phoneStr.slice(3, 6)} <div className="phone-circle-divider" />
          {phoneStr.slice(6)}
        </div>
      );
    }
  };
  formatAgentDesignation = (designation, teamMemberNumber = 1) => {
    const { listgenUserID } = this.props.agentData;
    let isWendyMarioni = listgenUserID === "102935";

    if (listgenUserID === "116385") {
      return "Strategic Real Estate Advisor";
    } else if (listgenUserID === "108245" && teamMemberNumber === 2) {
      return "REALTOR® | M.Ed.";
    } else if (listgenUserID === "112360") {
      return "Realtor® | Civil Engineer";
    } else if (listgenUserID === "100056") {
      return "Broker Associate/Managing Partner";
    } else if (listgenUserID === "103667") {
      return "Broker Associate & MBA – Held to a Higher Standard";
    } else if (listgenUserID === "106578") {
      return "Realtor® | Associate Sales Manager";
    } else if (listgenUserID === "110007") {
      return "";
    } else if (listgenUserID === "107248") {
      return "Realtor® | CRS | SRES | CNE & NHCB";
    } else if (isWendyMarioni) {
      return "Realtor® | CIPS™ | ABR™ | Relocation Specialist";
    } else if (
      designation === "Realtor" ||
      designation === "Broker Associate | Realtor"
    ) {
      return `${designation}®`;
    } else {
      return `${designation}`;
    }
  };
  render() {
    let {
      listgenUserFirstName,
      listgenUserLastName,
      agentDesignation,
      mobilePhoneNo,
      officePhoneNo,
      agentLicenseNumber,
      teamMembers,
      brokerageName,
      listgenUserID,
      teamName,
      specialBrokerageLogoURL,
      photoURL,
    } = this.props.agentData;
    let isRoseD = listgenUserID === "116097";
    let addEmailUnderDesignation = false;
    let addWebsiteUnderDesignation = isRoseD;
    //agent data comment
    let { homeOwnerURLQRCodePath } = this.props.hoData;
    const { formatAgentDesignation, getDesignationStyle } = this;
    const { isDemo, coverPageDetails, hasFlippedTeam } = this.props;

    const { coverPhotoCredit1, coverPhotoCredit2, photographerArtistName } =
      coverPageDetails;
    const { mlsAreaID, tagLine } = this.props.currentArea;
    const { shortenedDemoBrokerage, formatPhoneNoWithDashes } = propertyUtil;
    if (mlsAreaID === "ALA-3900AD") {
      mobilePhoneNo = officePhoneNo;
    }
    let alternateBrokerageUrl = {
      compass:
        "https://d2onbxnrte2nim.cloudfront.net/Horizontal_White_Compass%20Logo_500px.png",
      cb: "https://d2onbxnrte2nim.cloudfront.net/cb-stacked-brokerage-logo.png",
      "village-properties":
        "https://d2onbxnrte2nim.cloudfront.net/village-properties-logo2.png",
      intero: "https://d2onbxnrte2nim.cloudfront.net/intero-cover-logo.png",
      berkshire:
        "https://d2onbxnrte2nim.cloudfront.net/bhhs-stacked-cover-logo.png",
      sothebys:
        "https://d2onbxnrte2nim.cloudfront.net/sothebys-brokerage-logo.png",
    };
    let shortDemo = shortenedDemoBrokerage(brokerageName);

    let shortDemoURL = alternateBrokerageUrl[shortDemo];

    let defaultLogo;
    if (brokerageName.includes("Compass")) {
      defaultLogo = alternateBrokerageUrl["compass"];
    } else if (brokerageName.includes("Coldwell Banker")) {
      defaultLogo = alternateBrokerageUrl["cb"];
    } else if (brokerageName.includes("Village Properties")) {
      defaultLogo = alternateBrokerageUrl["village-properties"];
    } else if (brokerageName.includes("Intero")) {
      defaultLogo = alternateBrokerageUrl["intero"];
    } else if (brokerageName.includes("Berkshire Hathaway")) {
      defaultLogo = alternateBrokerageUrl["berkshire"];
    } else if (brokerageName.includes("Sotheby's")) {
      defaultLogo = alternateBrokerageUrl["sothebys"];
    }

    if (!specialBrokerageLogoURL && !isDemo) {
      specialBrokerageLogoURL = defaultLogo;
    }

    let slicedLogo =
      specialBrokerageLogoURL && specialBrokerageLogoURL.slice(38, -4);

    let demoSlicedLogo =
      alternateBrokerageUrl[shortDemo] &&
      alternateBrokerageUrl[shortDemo].slice(33, -4);

    let { isMemberOfTeam, emailAddress, websiteURL } = this.props.agentData;
    const normalizedListgenUserID = String(listgenUserID);
    const hasCoverPageOnlyTeamFlip =
      normalizedListgenUserID === "x" &&
      isMemberOfTeam &&
      Array.isArray(teamMembers) &&
      teamMembers.length >= 2;
    let isKerrySmith = listgenUserID === "102340";
    let isMissyWS = listgenUserID === "120441";
    let agentInfoBoxStyles;
    let isTeresaM = listgenUserID === "103680";
    if (isTeresaM) {
      agentInfoBoxStyles = "compass-logo-width-80";
    } else if (listgenUserID === "116399") {
      agentInfoBoxStyles = "compass-info-box mb-neg-45-m4-neg-10";
    } else if (listgenUserID === "109705" || listgenUserID === "116930") {
      agentInfoBoxStyles = "compass-info-box";
    } else if (listgenUserID === "114384") {
      agentInfoBoxStyles = "compass-info-box compass-logo-height-83-width-113";
    } else if (listgenUserID === "116936" || listgenUserID === "107230") {
      agentInfoBoxStyles = "compass-info-box lori-brokerage-logo-container";
    } else if (listgenUserID === "110007") {
      agentInfoBoxStyles = "xlisa-cochran-info-box";
    } else if (slicedLogo && slicedLogo.includes("mcguire-olson")) {
      agentInfoBoxStyles = "mcguire-olson-info-box";
    } else if (listgenUserID === "105790") {
      agentInfoBoxStyles = "no-margin-right-box-logo";
    } else if (listgenUserID === "x107373" || listgenUserID === "x107876") {
      agentInfoBoxStyles = "xhide-brokerage-logo";
    } else if (listgenUserID === "102450") {
      agentInfoBoxStyles = "compass-logo-mb-neg-45";
    } else if (listgenUserID === "104607") {
      agentInfoBoxStyles = "longer-agent-info-box-logo-38";
    } else if (brokerageName === "intero") {
      agentInfoBoxStyles = "larger-agent-info-box-width";
    } else if (listgenUserID === "105189") {
      agentInfoBoxStyles = "michael-noh-logo-and-portrait";
    } else if (listgenUserID === "104804") {
      agentInfoBoxStyles = "julie-baumann-logo-and-portrait";
    } else if (slicedLogo && slicedLogo.includes("Compass_SV-logo_White")) {
      slicedLogo = "compass-sv-info-box";
    } else if (listgenUserID === "105797") {
      agentInfoBoxStyles = "agent-info-box-65-perc";
    } else if (listgenUserID === "113597") {
      agentInfoBoxStyles = "compass-info-box alison-c-compass-logo";
    } else if (brokerageName.includes("Compass")) {
      agentInfoBoxStyles = "compass-info-box";
    }

    if (
      specialBrokerageLogoURL &&
      specialBrokerageLogoURL.includes(
        "specialBrokerageLogoURL",
        "bhhs-stacked-cover-logo.png",
      )
    ) {
      slicedLogo = "bhhs-stacked-cover-logo";
    }

    const isChristineC = listgenUserID === "116385";
    let specialLogoStyles;
    if (listgenUserID === "104597") {
      specialLogoStyles = "larger-compass-logo";
    }
    let coverPageInfoStyles = "";
    if ((listgenUserID === "105189") | (listgenUserID === "109796")) {
      coverPageInfoStyles = "larger-cover-page-info-styles";
    } else if (listgenUserID === "107373" || listgenUserID === "107876") {
      coverPageInfoStyles = "cover-page-info-team-right-aligned";
    } else if (isTeresaM) {
      coverPageInfoStyles = "cover-page-info-mb-100";
    }

    if (defaultLogo) {
      specialLogoStyles = defaultLogo.slice(41, -4);
    }
    let isKatherineHunt = listgenUserID === "105805";

    if (listgenUserID === "102843") {
      isMemberOfTeam = false;
      teamMembers = [];
    }
    const isAnnAlbanese = listgenUserID === "100063";
    const isJohnsons = listgenUserID === "100988";
    const isMarkWong = listgenUserID === "102450";
    const isLeeShantePappas = listgenUserID === "104480";
    const isSophieTsang = listgenUserID === "102567";
    const isHouy = listgenUserID === "105797";
    if (isLeeShantePappas) {
      listgenUserFirstName = "Lee + Shanté";
    }
    let isDawnThomas = listgenUserID === "102674";
    let isKyle3Team = listgenUserID === "103406";
    let isWendyMarioni = listgenUserID === "102935";
    let isTeamOf3 =
      isMemberOfTeam &&
      Array.isArray(teamMembers) &&
      teamMembers.length >= 3 &&
      (listgenUserID === "109938" ||
        listgenUserID === "109973" ||
        listgenUserID === "109657" ||
        listgenUserID === "109864" ||
        listgenUserID === "109879" ||
        listgenUserID === "116921" ||
        listgenUserID === "120373");

    const isKellyMahan = listgenUserID === "100661";

    const isLisaMcCollum = listgenUserID === "100656";
    const isJessieSessions = listgenUserID === "100474";
    const isStephanieSills = listgenUserID === "105068";
    const isMicheleManzone = listgenUserID === "112366";
    const isKristinArntz = listgenUserID === "100462";
    const isGaryPalacios = listgenUserID === "105790";
    const isLisaCochran = listgenUserID === "110007";

    const isCammieC = listgenUserID === "100652";
    const isGigi = listgenUserID === "107254";
    const isFlashberger = listgenUserID === "107253";
    const isGohn = listgenUserID === "107319";
    const isSamanthaC = listgenUserID === "107215";
    const isTaylorK = listgenUserID === "104793";
    const isDebKockos = listgenUserID === "106463";
    const isKarteek = listgenUserID === "113594";

    let presentedCreditStyle;

    if (isFlashberger || isStephanieSills || isGigi) {
      presentedCreditStyle = "stephanie-sills";
    } else if (isKellyMahan) {
      presentedCreditStyle = "mccollum";
    } else if (listgenUserID === "106031") {
      presentedCreditStyle = "maurry-vano-presented-credit";
    } else if (
      isLisaMcCollum ||
      isDawnThomas ||
      isCammieC ||
      isJessieSessions ||
      isSamanthaC ||
      isTaylorK ||
      isMicheleManzone
    ) {
      presentedCreditStyle = "dawn-thomas";
    } else if (isKatherineHunt) {
      presentedCreditStyle = "mccollum";
    } else if (isDawnThomas) {
      presentedCreditStyle = "mccollum";
    } else if (isKristinArntz) {
      presentedCreditStyle = "arntz";
    } else if (isGaryPalacios) {
      presentedCreditStyle = "arntz";
    } else if (isAnnAlbanese || listgenUserID === "101567") {
      presentedCreditStyle = "albanese";
    } else if (
      listgenUserID === "102712" ||
      listgenUserID === "101268" ||
      isKyle3Team ||
      isTeamOf3
    ) {
      presentedCreditStyle = "three-agent-presented";
    } else if (listgenUserID === "107876") {
      presentedCreditStyle = "presented-width-191";
    } else if (listgenUserID === "107373") {
      presentedCreditStyle = "presented-width-266";
    }

    const { phoneCircleDivider } = this;
    let fullName = `${listgenUserFirstName} ${listgenUserLastName}`;
    let secondAgent = "agent";
    if (isMemberOfTeam && teamMembers?.[1]) {
      secondAgent = `${teamMembers[1].firstName} ${teamMembers[1].lastName}`;
    }
    let isGummow = listgenUserID === "101566";

    let smallerNameAndPhoneFont =
      fullName.length > 18 || secondAgent.length > 18 || isGummow
        ? true
        : false;
    let isVait = listgenUserID === "101001";
    let hyphensOnPhoneNumber = false;
    if (listgenUserID === "103486") {
      hyphensOnPhoneNumber = true;
    }
    let isNegarFatemi = listgenUserID === "102734";

    let isErikaDemma = listgenUserID === "106107";

    let isJeanMarie = listgenUserID === "107012";

    let smallerAgentDesignation =
      agentDesignation &&
      agentDesignation.length >= 34 &&
      agentDesignation.length < 48;
    let xsAgentDesignation = agentDesignation && agentDesignation.length >= 48;
    let teamMember1xsAgentDesignation;
    if (
      isMemberOfTeam &&
      teamMembers[1].agentDesignation &&
      teamMembers[1].agentDesignation.length >= 45
    ) {
      teamMember1xsAgentDesignation = "no-uppercase-longer-agent-designation ";
    } else if (listgenUserID === "108245") {
      teamMember1xsAgentDesignation = "no-uppercase";
    }

    let coverPageInfoRowStyles = "";

    if (isTeamOf3) {
      coverPageInfoRowStyles = "cover-page-info-team-3";
    } else if (listgenUserID === "104519") {
      coverPageInfoRowStyles = "cover-page-info-bottom-105";
    } else if (listgenUserID === "104742") {
      coverPageInfoRowStyles = "cover-page-info-bottom-10";
    } else if (isDebKockos) {
      coverPageInfoRowStyles = "cover-page-info-bottom-160";
    } else if (listgenUserID === "112368") {
      coverPageInfoRowStyles = "cover-page-info-bottom-120";
    } else if (isSophieTsang) {
      coverPageInfoRowStyles = "higher-cover-info-215";
    } else if (listgenUserID === "112334") {
      coverPageInfoRowStyles = "black-cover-info";
    } else if (listgenUserID === "116936" || listgenUserID === "107230") {
      coverPageInfoRowStyles =
        "darkened-cover-info lori-olson-bottom-agent-info";
    } else if (isNegarFatemi) {
      coverPageInfoRowStyles = "higher-cover-info-1";
      presentedCreditStyle = "presented-by-700";
      agentInfoBoxStyles = "lower-cover-logo-1";
    } else if (listgenUserID === "104480") {
      let positioningStyles =
        !coverPhotoCredit1 && !coverPhotoCredit2
          ? "lower-cover-info-bottom-55"
          : "";

      coverPageInfoRowStyles = `${positioningStyles}`;
    } else if (listgenUserID === "x109954") {
      coverPageInfoRowStyles = "black-cover-info-row";
    } else if (listgenUserID === "113013") {
      coverPageInfoRowStyles = "cover-page-info-bottom-120";
    } else if (isChristineC) {
      coverPageInfoRowStyles = "cover-page-info-bottom-120";
    } else if (isMemberOfTeam == false) {
      coverPageInfoRowStyles = "cover-page-info-bottom-55";
    } else if (isMemberOfTeam) {
      coverPageInfoRowStyles = "cover-page-info-bottom-62";
    }

    let useTeamName = false;
    let teamNameText = "";
    if (listgenUserID === "116045") {
      teamNameText = "The Deborah Cole Team";
      useTeamName = true;
    } else if (listgenUserID === "101332") {
      teamNameText = "The Locals Team";
      useTeamName = true;
    } else if (listgenUserID === "112366") {
      useTeamName = true;
      teamNameText = `Michele and Leslie your Neighbor and Real Estate Experts`;
    }
    let longDesignation =
      (agentDesignation && agentDesignation.length >= 38) ||
      listgenUserID === "106578";

    let designationRowStyles = "";
    if (listgenUserID === "105224") {
      designationRowStyles = "designation-row-mt-18";
    }
    let hideAgentInfoShowLogo = false;

    if (photographerArtistName?.includes("Hide Agent Info & Show Logo")) {
      hideAgentInfoShowLogo = true;
    }
    let separateNameAndPhone = false;
    if (listgenUserID === "114384") {
      separateNameAndPhone = true;
    }

    let agentNameStyles = "";
    if (listgenUserID === "112993") {
      agentNameStyles = "agent-name-font-32-mb-4";
    }
    let teresaMCoverInfo = (
      <div className="agent-info-col">
        <div className="agent-and-phone">
          <p
            className={`agent-name ${
              smallerNameAndPhoneFont ? "smaller-name-and-phone" : ""
            }`}
          >
            {listgenUserFirstName} {listgenUserLastName}
          </p>
        </div>
        <div className="agent-and-phone mt-5">
          <div
            className={`agent-phone ${
              smallerNameAndPhoneFont ? "smaller-name-and-phone" : ""
            } `}
          >
            {phoneCircleDivider(mobilePhoneNo, fullName.length)}
          </div>
        </div>
        <div className={`designation-and-dre ${designationRowStyles}`}>
          <p
            className={`agent-designation ${
              smallerAgentDesignation ? "smaller-agent-designation" : ""
            } ${getDesignationStyle(agentDesignation)}`}
          >
            {formatAgentDesignation(agentDesignation)}
          </p>

          <p className="dre-word">DRE</p>
          <p className="dre-num"> # {agentLicenseNumber}</p>
        </div>
      </div>
    );
    const christineCWebsite =
      websiteURL && String(websiteURL).trim()
        ? String(websiteURL)
            .replace(/^https?:\/\//i, "")
            .replace(/^www\./i, "")
        : "ChristineChristiansen.com";

    // let christineCCoverInfo = (
    //   <div className="cover-page-christine-c-contact">
    //     <div className="cover-page-christine-c-details">
    //       <p className="cover-page-christine-c-line">
    //         {listgenUserFirstName} {listgenUserLastName}, MBA
    //       </p>
    //       <p className="cover-page-christine-c-line">
    //         {formatAgentDesignation(agentDesignation)}
    //       </p>
    //       <p className="cover-page-christine-c-line">
    //         DRE # {agentLicenseNumber}
    //       </p>
    //       <p className="cover-page-christine-c-line">
    //         {formatPhoneNoWithDashes(mobilePhoneNo)}
    //       </p>
    //       <p className="cover-page-christine-c-line">{christineCWebsite}</p>
    //     </div>
    //   </div>
    // );
    let christineCCoverInfo = (
      <div className="agent-info-col">
        <div className="agent-and-phone">
          <p
            className={`agent-name ${
              smallerNameAndPhoneFont ? "smaller-name-and-phone" : ""
            }`}
          >
            {listgenUserFirstName} {listgenUserLastName}, MBA
          </p>
        </div>

        <div className={`designation-and-dre ${designationRowStyles}`}>
          <p
            className={`agent-designation ${
              smallerAgentDesignation ? "smaller-agent-designation" : ""
            } ${getDesignationStyle(agentDesignation)} capitalized-agent-designation`}
          >
            {formatAgentDesignation(agentDesignation)}
          </p>

          <p className="dre-word">DRE</p>
          <p className="dre-num"> # {agentLicenseNumber}</p>
        </div>
        <div
          className={`agent-phone ${
            smallerNameAndPhoneFont ? "smaller-name-and-phone" : ""
          } `}
        >
          {phoneCircleDivider(mobilePhoneNo, fullName.length)}
        </div>

        <div
          className={`agent-phone ${
            smallerNameAndPhoneFont ? "smaller-name-and-phone" : ""
          } `}
        >
          christinechristiansen.com
        </div>
      </div>
    );
    if (hideAgentInfoShowLogo) {
      return (
        <div className={`qv4-cover-page-info-row ${coverPageInfoRowStyles}`}>
          <div className="qv4-cover-page-info">
            <div className="transparent-inner-container">
              <div className="agent-info-section flex-end-logo">
                <div className="small-team-info-col"></div>
                <div className="agent-info-box-logo">
                  <img
                    className={`${slicedLogo} ${
                      isMemberOfTeam && "team-logo"
                    } ${specialLogoStyles}`}
                    src={
                      specialBrokerageLogoURL
                        ? specialBrokerageLogoURL
                        : defaultLogo
                    }
                    alt={specialBrokerageLogoURL}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (isFlashberger) {
      return (
        <div className="flashberger-cover-info">
          <img
            src="https://d2onbxnrte2nim.cloudfront.net/061725_SueFlashberger_CoverFooter.jpg"
            className="flashberger-cover-info-img"
            alt="Flashberger"
          />
        </div>
      );
    } else if (isStephanieSills) {
      return (
        <div className="stephanie-sills-bottom-cover-container">
          <div className="stephanie-sills-bottom-cover-inner-container">
            <div className="stephanie-sills-cover-portrait">
              <img
                src="https://d2onbxnrte2nim.cloudfront.net/stephanie-cropped-headshot.jpg"
                alt="Stephanie Sills Portrait"
              />
            </div>
            <div className="stephanie-sills-brokerage-logo-container">
              <img
                src="https://d2onbxnrte2nim.cloudfront.net/compass-logo-horizontal.png"
                alt="Compass logo"
              />
            </div>

            <div className="stephanie-sills-cover-text-info-section">
              <p className="stephanie-sills-cover-text-name">STEPHANIE SILLS</p>
              <p className="stephanie-sills-cover-designation">
                MBA, MIM, Realtor®{" "}
              </p>
              <p className="stephanie-sills-cover-dre">DRE 02060529</p>
              <p className="stephanie-sills-cover-email">
                STEPHANIESILLSREALTY.COM
              </p>
              <p className="stephanie-sills-cover-brokerage-email">
                STEPHANIE.SILLS@COMPASS.COM
              </p>
              <p className="stephanie-sills-cover-number">650.678.5707</p>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className={`qv4-cover-page-info-row ${coverPageInfoRowStyles}`}>
          {isKatherineHunt && (
            <div className="katherine-hunt-logo">
              <img
                src="https://d2onbxnrte2nim.cloudfront.net/non-covers/katherine-hunt-qr-code.png"
                alt="Katherine Hunt QR Code"
              />
            </div>
          )}

          {isKellyMahan && (
            <div className="kelly-mahan-cover-logo">
              <img
                src="https://d2onbxnrte2nim.cloudfront.net/non-covers/062926_kelly-mahan-headshot.jpg"
                alt="Kelly Mahan Portrait"
              />
            </div>
          )}

          {isStephanieSills && (
            <div className="stephanie-sills-cover-logo">
              <img
                src="https://d2onbxnrte2nim.cloudfront.net/042125_stephanie-cropped-headshot.jpg"
                alt="Stephanie Sills Portrait"
              />
            </div>
          )}

          {isGigi && (
            <div className="stephanie-sills-cover-logo">
              <img src={photoURL} alt="Gigi Srour Portrait" />
            </div>
          )}

          {isGaryPalacios && (
            <div className="gary-palacios-cover-logo">
              <img
                src="https://d2onbxnrte2nim.cloudfront.net/non-covers/092024_GPalacios_Logo_wht-reverse.png"
                alt="Gary Palacios logo"
              />
            </div>
          )}
          {isKristinArntz && (
            <div className="kristin-arntz-cover-logo">
              <img
                src="https://d2onbxnrte2nim.cloudfront.net/kristin-arntz-cover-logo.png"
                alt="Kristin Arntz logo"
              />
            </div>
          )}

          {isLisaMcCollum && (
            <div className="lisa-mccollum-cover-logo">
              <img
                src="https://d2onbxnrte2nim.cloudfront.net/111524_LisaMcC_frontCovr.jpg"
                alt="Calgano Hamilton Logo"
              />
            </div>
          )}
          {isJessieSessions && (
            <div className="lisa-mccollum-cover-logo">
              <img
                src={photoURL}
                alt="Calgano Hamilton Logo"
                className="jessie-sessions-cover-headshot"
              />
            </div>
          )}
          {isMicheleManzone && (
            <div className="michele-manzone-cover-portrait">
              <img src={photoURL} alt="Michele Manzone Portrait" />
            </div>
          )}

          {isCammieC && (
            <div className="lisa-mccollum-cover-logo">
              <img
                src="https://d2onbxnrte2nim.cloudfront.net/031125_CammieCalcagno_frontCovr.jpg"
                alt="Calgano Hamilton Logo"
              />
            </div>
          )}

          {isTaylorK && (
            <div className="taylor-k-cover-headshot">
              <img src={photoURL} alt="Taylor K Logo" />
            </div>
          )}
          {isSamanthaC && (
            <div className="samantha-costello-cover-headshot-container">
              <img
                src="https://d2onbxnrte2nim.cloudfront.net/080825_SamanthaCostello_Covr-HeadShot.jpg"
                alt="Samantha Costello headshot"
              />
            </div>
          )}

          {isAnnAlbanese && (
            <div className="global-luxury-cb-cover-logo">
              <img
                src="https://d2onbxnrte2nim.cloudfront.net/pres_circle_bronze_500x500px.png"
                alt="Global Luxury Coldwell Banker Logo"
              />
            </div>
          )}
          {listgenUserID === "101567" && (
            <div className="global-luxury-cb-cover-logo">
              <img
                src="https://d2onbxnrte2nim.cloudfront.net/INternational+Presidents+Elite+BlackSIL.png"
                alt="Global Luxury Coldwell Banker Logo"
              />
            </div>
          )}

          {isVait && (
            <div className="vait-cover-logo">
              <img src={photoURL} alt="Annette Vait Profile Photo" />
            </div>
          )}

          {isVait ? (
            <div className={"vait-cover-info"}>
              <div className="vait-transparent-inner-container">
                <div className={"vait-agent-info-section"}>
                  <div className="vait-agent-info-col">
                    <div className="vait-agent-and-phone">
                      <p
                        className={`vait-agent-name ${
                          smallerNameAndPhoneFont
                            ? "smaller-name-and-phone"
                            : ""
                        } `}
                      >
                        {listgenUserFirstName} {listgenUserLastName}
                      </p>
                    </div>
                    <div className={`vait-row`}>
                      <p className="vait-designation caps">Realtor </p>{" "}
                      <p className="vait-designation-span">-</p>
                      <span className="vait-mx-2"></span>
                      <p className="vait-designation">Broker Associate</p>
                    </div>
                    <div className="vait-designation-and-dre">
                      <p className="vait-dre-word">DRE</p>
                      <p className="vait-dre-num"> # {agentLicenseNumber}</p>
                    </div>
                    <div className={`vait-agent-phone-number`}>
                      {phoneCircleDivider(mobilePhoneNo, fullName.length)}
                    </div>
                  </div>

                  <div className={`agent-info-box-logo ${agentInfoBoxStyles}`}>
                    {specialBrokerageLogoURL ? (
                      <img
                        className={`${slicedLogo} ${
                          isMemberOfTeam && "team-logo"
                        } ${specialLogoStyles}`}
                        src={specialBrokerageLogoURL}
                        alt={specialBrokerageLogoURL}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : isNegarFatemi ? (
            <div className="qv4-cover-page-info">
              <div
                className={`agent-info-presented-by ${presentedCreditStyle}`}
              >
                Presented by
              </div>
              <div className="transparent-inner-container">
                <div className="agent-info-section">
                  <div className="agent-info-col bigger-bolder-agent-info-col">
                    <div className="agent-and-phone">
                      <p className={`agent-name agent-name-font-38-bold-600 `}>
                        {listgenUserFirstName} {listgenUserLastName}
                      </p>
                    </div>
                    <div className="negar-award-agent-container">
                      <p className="negar-award-agent">Award-Winning Agent</p>
                    </div>
                    <p className="cover-photo-tagline">{tagLine}</p>
                    <div className={`agent-phone`}>
                      {phoneCircleDivider(mobilePhoneNo, fullName.length)}
                    </div>
                    <div
                      className={`designation-and-dre ${designationRowStyles}`}
                    >
                      <p
                        className={`agent-designation ${
                          smallerAgentDesignation
                            ? "smaller-agent-designation"
                            : ""
                        } `}
                      >
                        {formatAgentDesignation(agentDesignation)}
                      </p>
                      <p className="dre-word">DRE</p>
                      <p className="dre-num"> # {agentLicenseNumber}</p>
                    </div>
                  </div>

                  <div
                    className={`agent-info-box-logo ${
                      brokerageName.includes("Keller Williams") &&
                      "longer-agent-info-box-logo"
                    } ${agentInfoBoxStyles}`}
                  >
                    <img
                      className={`${slicedLogo} ${specialLogoStyles}`}
                      src={
                        specialBrokerageLogoURL
                          ? specialBrokerageLogoURL
                          : defaultLogo
                      }
                      alt={specialBrokerageLogoURL}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : listgenUserID === "104504" ? (
            <div
              className={
                "qv4-cover-page-info " +
                (isMemberOfTeam ? "team " : "") +
                "custom-sam-and-gina-cover-info"
              }
            >
              <div
                className={`agent-info-presented-by sam-and-gina-custom-presented`}
              >
                Presented by
              </div>
              <div className="transparent-inner-container">
                <div
                  className={
                    "agent-info-section " + (isMemberOfTeam ? "team" : "")
                  }
                >
                  {isMemberOfTeam ? (
                    <div className="small-team-info-col">
                      <div className={`small-team-agent-container`}>
                        <div className="small-team-headshot-container">
                          <img
                            className="small-team-headshot-img"
                            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/gina-m-headshot.jpg"
                            alt="Gina Headshot"
                          />
                        </div>
                        <div className="small-team-agent-col">
                          <div className="small-team-agent-and-phone">
                            <div
                              className={
                                "small-team-agent-name " +
                                (smallerNameAndPhoneFont
                                  ? "small-smaller-name-and-phone"
                                  : "")
                              }
                            >
                              {listgenUserFirstName} {listgenUserLastName}
                            </div>

                            <div className="small-team-vertical-divider" />
                            <div
                              className={
                                "small-team-agent-phone " +
                                (smallerNameAndPhoneFont
                                  ? "smaller-name-and-phone"
                                  : "")
                              }
                            >
                              {phoneCircleDivider(
                                mobilePhoneNo,
                                null,
                                hyphensOnPhoneNumber,
                              )}
                            </div>
                          </div>
                          <div className={`small-team-sub-info`}>
                            <div className="small-team-designation-and-dre">
                              <p
                                className={`small-designation-text ${
                                  smallerNameAndPhoneFont
                                    ? "small-smaller-designation"
                                    : ""
                                } `}
                              >
                                {formatAgentDesignation(agentDesignation)}
                              </p>
                              <div className="small-dre-row">
                                <p className="small-dre-word">dre</p>{" "}
                                <p className="small-dre-num">
                                  #{agentLicenseNumber}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={`small-team-agent-container`}>
                        <div className="small-team-headshot-container">
                          <img
                            className="small-team-headshot-img"
                            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/samantha-s-headshot.jpg"
                            alt="Samantha Headshot"
                          />
                        </div>
                        <div className="small-team-agent-col">
                          <div className="small-team-agent-and-phone">
                            <p
                              className={
                                "small-team-agent-name " +
                                (smallerNameAndPhoneFont
                                  ? "small-smaller-name-and-phone"
                                  : "")
                              }
                            >
                              {teamMembers[1].firstName}{" "}
                              {teamMembers[1].lastName}
                            </p>
                            <div className="small-team-vertical-divider" />
                            {listgenUserID !== "100027" && (
                              <div
                                className={
                                  "small-team-agent-phone " +
                                  (smallerNameAndPhoneFont
                                    ? "small-smaller-name-and-phone"
                                    : "")
                                }
                              >
                                {phoneCircleDivider(
                                  teamMembers[1].phone,
                                  null,
                                  hyphensOnPhoneNumber,
                                )}
                              </div>
                            )}
                          </div>
                          <div className={`small-team-sub-info`}>
                            <div className="small-team-designation-and-dre">
                              <p
                                className={`small-designation-text ${teamMember1xsAgentDesignation} ${
                                  smallerNameAndPhoneFont
                                    ? "small-smaller-designation"
                                    : ""
                                }`}
                              >
                                {formatAgentDesignation(
                                  teamMembers[1].agentDesignation,
                                  2,
                                )}
                              </p>
                              <div className="small-dre-row">
                                <p className="small-dre-word">dre</p>
                                <p className="small-dre-num">
                                  {" "}
                                  #{teamMembers[1].agentLicenseNumber}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="agent-info-col">
                      <div className="agent-and-phone">
                        {listgenUserID === "100988" ? (
                          <p className="agent-name smaller-name-and-phone">
                            Dianne & Brianna {listgenUserLastName}
                          </p>
                        ) : (
                          <p
                            className={`agent-name ${
                              smallerNameAndPhoneFont
                                ? "smaller-name-and-phone"
                                : ""
                            } `}
                          >
                            {listgenUserFirstName} {listgenUserLastName}
                          </p>
                        )}
                        <div className="vertical-divider" />
                        {!isGummow && (
                          <div
                            className={`agent-phone ${
                              smallerNameAndPhoneFont
                                ? "smaller-name-and-phone"
                                : ""
                            } `}
                          >
                            {phoneCircleDivider(mobilePhoneNo, fullName.length)}
                          </div>
                        )}
                      </div>

                      {isJohnsons ? (
                        <div className="designation-and-dre">
                          <p
                            className={`agent-designation ${
                              smallerNameAndPhoneFont
                                ? "smaller-agent-designation"
                                : ""
                            } `}
                          >
                            Realtors
                          </p>
                          <p className="dre-word">DRE</p>
                          <p className="dre-num"> # 00947199 </p>
                          <p className="mx-6"> / </p>
                          <p className="dre-word">DRE</p>
                          <p className="dre-num"> # 01943572</p>
                        </div>
                      ) : isLeeShantePappas ? (
                        <div>
                          <div className="designation-and-dre">
                            <p
                              className={`agent-designation ${
                                smallerAgentDesignation
                                  ? "smaller-agent-designation"
                                  : ""
                              } `}
                            >
                              {formatAgentDesignation(agentDesignation)}
                            </p>
                            <p className="dre-word">DRE</p>
                            <p className="dre-num"> # {agentLicenseNumber}</p>
                          </div>

                          <div className="designation-and-dre">
                            <p
                              className={`agent-designation ${
                                smallerAgentDesignation
                                  ? "smaller-agent-designation"
                                  : ""
                              } `}
                            >
                              Market Experts, Personal Touch? We're Just a Call
                              Away.
                            </p>
                          </div>
                        </div>
                      ) : longDesignation ? (
                        <div className="designation-and-dre-col">
                          <div className="designation-and-dre">
                            <p
                              className={`agent-designation ${
                                smallerAgentDesignation
                                  ? "smaller-agent-designation"
                                  : ""
                              } ${getDesignationStyle(agentDesignation)}`}
                            >
                              {formatAgentDesignation(agentDesignation)}
                            </p>
                          </div>
                          <div className="designation-and-dre">
                            <p className="dre-word">DRE</p>
                            <p className="dre-num"> # {agentLicenseNumber}</p>
                          </div>
                        </div>
                      ) : (
                        <div
                          className={`designation-and-dre ${designationRowStyles}`}
                        >
                          <p
                            className={`agent-designation ${
                              smallerAgentDesignation
                                ? "smaller-agent-designation"
                                : ""
                            } ${getDesignationStyle(agentDesignation)}`}
                          >
                            {formatAgentDesignation(agentDesignation)}
                          </p>
                          <p className="dre-word">DRE</p>
                          <p className="dre-num"> # {agentLicenseNumber}</p>
                        </div>
                      )}
                    </div>
                  )}
                  <div
                    className={`agent-info-box-logo ${
                      brokerageName.includes("Keller Williams") &&
                      "longer-agent-info-box-logo"
                    } ${
                      (isKatherineHunt ||
                        isKellyMahan ||
                        isStephanieSills ||
                        isMicheleManzone ||
                        isFlashberger ||
                        isGigi ||
                        isLisaMcCollum ||
                        isJessieSessions ||
                        isCammieC ||
                        isSamanthaC ||
                        isAnnAlbanese ||
                        isDawnThomas ||
                        listgenUserID === "101567" ||
                        mlsAreaID === "SCL-16N" ||
                        mlsAreaID === "SCL-16A" ||
                        isTaylorK) &&
                      "agent-logo-mr"
                    } ${agentInfoBoxStyles}`}
                  >
                    {isDemo ? (
                      <img
                        className={`${demoSlicedLogo} ${
                          isMemberOfTeam && "team-logo"
                        }`}
                        src={shortDemoURL}
                        alt={`${brokerageName} logo`}
                      />
                    ) : specialBrokerageLogoURL ? (
                      <img
                        className={`${slicedLogo} ${
                          isMemberOfTeam && "team-logo"
                        } ${specialLogoStyles}`}
                        src={
                          specialBrokerageLogoURL
                            ? specialBrokerageLogoURL
                            : defaultLogo
                        }
                        alt={specialBrokerageLogoURL}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : hasCoverPageOnlyTeamFlip ? (
            <div
              className={`qv4-cover-page-info ${isMemberOfTeam && "team"} ${
                coverPageInfoStyles && coverPageInfoStyles
              }`}
            >
              <div
                className={`agent-info-presented-by ${presentedCreditStyle}`}
              >
                Presented by
              </div>
              <div className="transparent-inner-container">
                <div
                  className={
                    "agent-info-section " + (isMemberOfTeam ? "team" : "")
                  }
                >
                  <div className="team-info-col">
                    <div className={`team-agent-container`}>
                      <div className="team-agent-col">
                        <div className="team-agent-and-phone">
                          <div
                            className={
                              "team-agent-name " +
                              (smallerNameAndPhoneFont
                                ? "smaller-name-and-phone"
                                : "")
                            }
                          >
                            {teamMembers[1].firstName} {teamMembers[1].lastName}
                          </div>

                          <div className="team-vertical-divider" />
                          <div
                            className={
                              "team-agent-phone " +
                              (smallerNameAndPhoneFont
                                ? "smaller-name-and-phone"
                                : "")
                            }
                          >
                            {phoneCircleDivider(
                              teamMembers[1].phone,
                              null,
                              hyphensOnPhoneNumber,
                            )}
                          </div>
                        </div>
                        <div className={`team-sub-info`}>
                          <div className="team-designation-and-dre">
                            <p
                              className={`designation-text ${teamMember1xsAgentDesignation} ${
                                smallerNameAndPhoneFont
                                  ? "smaller-designation"
                                  : ""
                              }`}
                            >
                              {formatAgentDesignation(
                                teamMembers[1].agentDesignation,
                                2,
                              )}
                            </p>

                            <div className="dre-row">
                              <p className="dre-word">dre</p>{" "}
                              <p className="dre-num">
                                #{teamMembers[1].agentLicenseNumber}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={`team-agent-container`}>
                      <div className="team-agent-col">
                        <div className="team-agent-and-phone">
                          <p
                            className={
                              "team-agent-name " +
                              (smallerNameAndPhoneFont
                                ? "smaller-name-and-phone"
                                : "")
                            }
                          >
                            {teamMembers[0].firstName} {teamMembers[0].lastName}
                          </p>
                          <div className="team-vertical-divider" />

                          <div
                            className={
                              "team-agent-phone " +
                              (smallerNameAndPhoneFont
                                ? "smaller-name-and-phone"
                                : "")
                            }
                          >
                            {phoneCircleDivider(
                              teamMembers[0].phone,
                              null,
                              hyphensOnPhoneNumber,
                            )}
                          </div>
                        </div>
                        <div className={`team-sub-info`}>
                          <div className="team-designation-and-dre">
                            <p
                              className={`designation-text ${
                                smallerNameAndPhoneFont
                                  ? "smaller-designation"
                                  : ""
                              } `}
                            >
                              {formatAgentDesignation(
                                teamMembers[0].agentDesignation,
                              )}
                            </p>

                            <div className="dre-row">
                              <p className="dre-word">dre</p>
                              <p className="dre-num">
                                #{teamMembers[0].agentLicenseNumber}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={`agent-info-box-logo  ${agentInfoBoxStyles}`}>
                    {specialBrokerageLogoURL ? (
                      <img
                        className={`${slicedLogo} ${
                          isMemberOfTeam && "team-logo"
                        } ${specialLogoStyles}`}
                        src={
                          specialBrokerageLogoURL
                            ? specialBrokerageLogoURL
                            : defaultLogo
                        }
                        alt={specialBrokerageLogoURL}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : hasFlippedTeam ? (
            <div
              className={`qv4-cover-page-info ${isMemberOfTeam && "team"} ${
                coverPageInfoStyles && coverPageInfoStyles
              }`}
            >
              <div
                className={`agent-info-presented-by ${presentedCreditStyle}`}
              >
                Presented by
              </div>
              <div className="transparent-inner-container">
                <div
                  className={
                    "agent-info-section " + (isMemberOfTeam ? "team" : "")
                  }
                >
                  <div className="team-info-col">
                    <div className={`team-agent-container`}>
                      <div className="team-agent-col">
                        <div className="team-agent-and-phone">
                          <div
                            className={
                              "team-agent-name " +
                              (smallerNameAndPhoneFont
                                ? "smaller-name-and-phone"
                                : "")
                            }
                          >
                            {teamMembers[1].firstName} {teamMembers[1].lastName}
                          </div>

                          <div className="team-vertical-divider" />
                          <div
                            className={
                              "team-agent-phone " +
                              (smallerNameAndPhoneFont
                                ? "smaller-name-and-phone"
                                : "")
                            }
                          >
                            {phoneCircleDivider(
                              teamMembers[1].phone,
                              null,
                              hyphensOnPhoneNumber,
                            )}
                          </div>
                        </div>
                        <div className={`team-sub-info`}>
                          <div className="team-designation-and-dre">
                            <p
                              className={`designation-text ${teamMember1xsAgentDesignation} ${
                                smallerNameAndPhoneFont
                                  ? "smaller-designation"
                                  : ""
                              }`}
                            >
                              {formatAgentDesignation(
                                teamMembers[1].agentDesignation,
                                2,
                              )}
                            </p>

                            <div className="dre-row">
                              <p className="dre-word">dre</p>{" "}
                              <p className="dre-num">
                                #{teamMembers[1].agentLicenseNumber}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={`team-agent-container`}>
                      <div className="team-agent-col">
                        <div className="team-agent-and-phone">
                          <p
                            className={
                              "team-agent-name " +
                              (smallerNameAndPhoneFont
                                ? "smaller-name-and-phone"
                                : "")
                            }
                          >
                            {listgenUserFirstName} {listgenUserLastName}
                          </p>
                          <div className="team-vertical-divider" />

                          <div
                            className={
                              "team-agent-phone " +
                              (smallerNameAndPhoneFont
                                ? "smaller-name-and-phone"
                                : "")
                            }
                          >
                            {phoneCircleDivider(
                              mobilePhoneNo,
                              null,
                              hyphensOnPhoneNumber,
                            )}
                          </div>
                        </div>
                        <div className={`team-sub-info`}>
                          <div className="team-designation-and-dre">
                            <p
                              className={`designation-text ${
                                smallerNameAndPhoneFont
                                  ? "smaller-designation"
                                  : ""
                              } `}
                            >
                              {formatAgentDesignation(agentDesignation)}
                            </p>

                            <div className="dre-row">
                              <p className="dre-word">dre</p>
                              <p className="dre-num"> #{agentLicenseNumber}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={`agent-info-box-logo  ${agentInfoBoxStyles}`}>
                    {specialBrokerageLogoURL ? (
                      <img
                        className={`${slicedLogo} ${
                          isMemberOfTeam && "team-logo"
                        } ${specialLogoStyles}`}
                        src={
                          specialBrokerageLogoURL
                            ? specialBrokerageLogoURL
                            : defaultLogo
                        }
                        alt={specialBrokerageLogoURL}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div
              className={`qv4-cover-page-info ${isMemberOfTeam && "team"} ${
                listgenUserID === "" && "cover-info-three-team"
              } ${isGummow && "qv4-gummow-cover-page-info"} ${
                coverPageInfoStyles && coverPageInfoStyles
              }`}
            >
              <div
                className={`agent-info-presented-by ${presentedCreditStyle}`}
              >
                {mlsAreaID === "1522155"
                  ? ""
                  : listgenUserID === "105795"
                    ? "Presented by the Celotti Group"
                    : "Presented by"}{" "}
                {useTeamName && teamNameText}
              </div>
              <div className="transparent-inner-container">
                {listgenUserID === "102548" && (
                  <div className="lori-b-cover-photo-logo">
                    <img
                      src="https://d2onbxnrte2nim.cloudfront.net/LoriBuecheler_LogoWhite_012025.png"
                      alt="Lori's Logo"
                    />
                  </div>
                )}
                <div
                  className={
                    "agent-info-section " + (isMemberOfTeam ? "team" : "")
                  }
                >
                  {isMemberOfTeam &&
                  !isKerrySmith &&
                  !isLeeShantePappas &&
                  !isMissyWS ? (
                    <div className="team-info-col">
                      <div className={`team-agent-container`}>
                        <div className="team-agent-col">
                          <div className="team-agent-and-phone">
                            {listgenUserID === "103486" ? (
                              <div
                                className={
                                  "team-agent-name " +
                                  (smallerNameAndPhoneFont
                                    ? "smaller-name-and-phone"
                                    : "")
                                }
                              >
                                {listgenUserFirstName} G. {listgenUserLastName}
                              </div>
                            ) : (
                              <div
                                className={
                                  "team-agent-name " +
                                  (smallerNameAndPhoneFont
                                    ? "smaller-name-and-phone"
                                    : "")
                                }
                              >
                                {listgenUserFirstName} {listgenUserLastName}
                              </div>
                            )}

                            {listgenUserID !== "104519" && (
                              <>
                                <div className="team-vertical-divider" />
                                <div
                                  className={
                                    "team-agent-phone " +
                                    (smallerNameAndPhoneFont
                                      ? "smaller-name-and-phone"
                                      : "")
                                  }
                                >
                                  {phoneCircleDivider(
                                    mobilePhoneNo,
                                    null,
                                    hyphensOnPhoneNumber,
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                          <div className={`team-sub-info`}>
                            {listgenUserID === "105896" ? (
                              <div className="team-designation-and-dre column-designation-dre">
                                <p
                                  className={`designation-text  ${
                                    (xsAgentDesignation ||
                                      smallerAgentDesignation) &&
                                    "xs-agent-designation"
                                  }`}
                                >
                                  {formatAgentDesignation(agentDesignation)}
                                </p>

                                <div className="dre-row">
                                  <p className="dre-word">DRE</p>

                                  <p className="dre-num">
                                    {" "}
                                    # {agentLicenseNumber}
                                  </p>
                                </div>
                              </div>
                            ) : (
                              <div className="team-designation-and-dre">
                                {!isMarkWong && (
                                  <p
                                    className={`designation-text ${
                                      smallerNameAndPhoneFont
                                        ? "smaller-designation"
                                        : ""
                                    } `}
                                  >
                                    {formatAgentDesignation(agentDesignation)}
                                  </p>
                                )}
                                <div className="dre-row">
                                  <p className="dre-word">dre</p>{" "}
                                  <p className="dre-num">
                                    #{agentLicenseNumber}
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className={`team-agent-container`}>
                        <div className="team-agent-col">
                          <div className="team-agent-and-phone">
                            <p
                              className={
                                "team-agent-name " +
                                (smallerNameAndPhoneFont
                                  ? "smaller-name-and-phone"
                                  : "")
                              }
                            >
                              {teamMembers[1].firstName}{" "}
                              {teamMembers[1].lastName}
                            </p>
                            {listgenUserID !== "104519" && (
                              <>
                                <div className="team-vertical-divider" />
                                {listgenUserID !== "100027" && (
                                  <div
                                    className={
                                      "team-agent-phone " +
                                      (smallerNameAndPhoneFont
                                        ? "smaller-name-and-phone"
                                        : "")
                                    }
                                  >
                                    {phoneCircleDivider(
                                      teamMembers[1].phone,
                                      null,
                                      hyphensOnPhoneNumber,
                                    )}
                                  </div>
                                )}
                              </>
                            )}
                          </div>

                          <div className={`team-sub-info`}>
                            {listgenUserID === "107270" ? (
                              <div className="team-designation-and-dre column-designation-dre">
                                <p
                                  className={`designation-text  ${teamMember1xsAgentDesignation}${
                                    smallerAgentDesignation &&
                                    "xs-agent-designation"
                                  }`}
                                >
                                  {formatAgentDesignation(
                                    teamMembers[1].agentDesignation,
                                    2,
                                  )}
                                </p>

                                <div className="dre-row">
                                  <p className="dre-word">DRE</p>

                                  <p className="dre-num">
                                    {" "}
                                    # {teamMembers[1].agentLicenseNumber}
                                  </p>
                                </div>
                              </div>
                            ) : (
                              <div className="team-designation-and-dre">
                                {!isMarkWong && (
                                  <p
                                    className={`designation-text ${teamMember1xsAgentDesignation} ${
                                      smallerNameAndPhoneFont
                                        ? "smaller-designation"
                                        : ""
                                    }`}
                                  >
                                    {formatAgentDesignation(
                                      teamMembers[1].agentDesignation,
                                      2,
                                    )}
                                  </p>
                                )}

                                <div className="dre-row">
                                  <p className="dre-word">dre</p>
                                  <p className="dre-num">
                                    {" "}
                                    #{teamMembers[1].agentLicenseNumber}
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>

                          {listgenUserID === "106031" && (
                            <div className="maurry-cover-info-row">
                              <img
                                src="https://d2onbxnrte2nim.cloudfront.net/non-covers/cropped-maurry-vano-white-transparent.png"
                                alt="Vano Maurry Logo"
                                className="maurry-cover-info-agent-logo"
                              />{" "}
                              <img
                                className="maurry-cover-info-brokerage-logo"
                                src={
                                  specialBrokerageLogoURL
                                    ? specialBrokerageLogoURL
                                    : defaultLogo
                                }
                                alt={specialBrokerageLogoURL}
                              />
                            </div>
                          )}
                          {isDebKockos && (
                            <div className="deb-kockos-presented-by-text">
                              The Dwyer Group
                            </div>
                          )}
                          {listgenUserID === "104519" && (
                            <div className="team-agent-and-phone">
                              <div
                                className={
                                  "team-agent-name " +
                                  (smallerNameAndPhoneFont
                                    ? "smaller-name-and-phone"
                                    : "")
                                }
                              >
                                Contact us:{" "}
                                {phoneCircleDivider(
                                  mobilePhoneNo,
                                  null,
                                  hyphensOnPhoneNumber,
                                  true,
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      {isTeamOf3 ? (
                        <div className="team-agent-container smaller-height">
                          <div className="team-agent-col">
                            <div className="team-agent-and-phone">
                              <p
                                className={
                                  "team-agent-name " +
                                  (smallerNameAndPhoneFont
                                    ? "smaller-name-and-phone"
                                    : "")
                                }
                              >
                                {teamMembers[2].firstName}{" "}
                                {teamMembers[2].lastName}
                              </p>
                              <div className="team-vertical-divider" /> 
                              <div
                                className={
                                  "team-agent-phone " +
                                  (smallerNameAndPhoneFont
                                    ? "smaller-name-and-phone"
                                    : "")
                                }
                              >
                                {phoneCircleDivider(
                                  teamMembers[2].phone,
                                  null,
                                  hyphensOnPhoneNumber,
                                )}
                              </div>
                            </div>
                            <div className={`team-sub-info`}>
                              <div className="team-designation-and-dre">
                                <p
                                  className={`designation-text ${
                                    smallerNameAndPhoneFont
                                      ? "smaller-designation"
                                      : ""
                                  } ${getDesignationStyle(
                                    teamMembers[2].agentDesignation,
                                  )}`}
                                >
                                  {formatAgentDesignation(
                                    teamMembers[2].agentDesignation,
                                  )}
                                </p>
                                <div className="dre-row">
                                  <p className="dre-word">dre</p>
                                  <p className="dre-num">
                                    {" "}
                                    #{teamMembers[2].agentLicenseNumber}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : listgenUserID === "102712" ||
                        listgenUserID === "101268" ||
                        isKyle3Team ? (
                        <div className="team-agent-container smaller-height">
                          <div className="team-agent-col">
                            <div className="team-agent-and-phone">
                              <p
                                className={
                                  "team-agent-name " +
                                  (smallerNameAndPhoneFont
                                    ? "smaller-name-and-phone"
                                    : "")
                                }
                              >
                                {teamMembers[2].firstName}{" "}
                                {teamMembers[2].lastName}
                              </p>
                              <div className="team-vertical-divider" /> 
                              <div
                                className={
                                  "team-agent-phone " +
                                  (smallerNameAndPhoneFont
                                    ? "smaller-name-and-phone"
                                    : "")
                                }
                              >
                                {phoneCircleDivider(
                                  teamMembers[2].phone,
                                  null,
                                  hyphensOnPhoneNumber,
                                )}
                              </div>
                            </div>
                            <div className={`team-sub-info`}>
                              <div className="team-designation-and-dre">
                                <p
                                  className={`designation-text ${
                                    smallerNameAndPhoneFont
                                      ? "smaller-designation"
                                      : ""
                                  } ${getDesignationStyle(
                                    teamMembers[2].agentDesignation,
                                  )}`}
                                >
                                  {formatAgentDesignation(
                                    teamMembers[2].agentDesignation,
                                  )}
                                </p>
                                <div className="dre-row">
                                  <p className="dre-word">dre</p>
                                  <p className="dre-num">
                                    {" "}
                                    #{teamMembers[2].agentLicenseNumber}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : isKerrySmith ? (
                    <div className="agent-info-col">
                      <div className="agent-and-phone">
                        <p
                          className={`agent-name ${
                            smallerNameAndPhoneFont
                              ? "smaller-name-and-phone"
                              : ""
                          } `}
                        >
                          {teamName}
                        </p>

                        <div className="vertical-divider" />

                        <div
                          className={`agent-phone ${
                            smallerNameAndPhoneFont
                              ? "smaller-name-and-phone"
                              : ""
                          } `}
                        >
                          {phoneCircleDivider(mobilePhoneNo, fullName.length)}
                        </div>
                      </div>

                      <div
                        className={`designation-and-dre ${designationRowStyles}`}
                      >
                        <p
                          className={`agent-designation ${
                            smallerAgentDesignation
                              ? "smaller-agent-designation"
                              : ""
                          } `}
                        >
                          {formatAgentDesignation(agentDesignation)}
                        </p>
                        <p className="dre-word">DRE</p>
                        <p className="dre-num"> # {agentLicenseNumber}</p>
                      </div>
                    </div>
                  ) : isChristineC ? (
                    christineCCoverInfo
                  ) : isTeresaM ? (
                    teresaMCoverInfo
                  ) : separateNameAndPhone ? (
                    <div className="agent-info-col">
                      <div className="agent-and-phone">
                        <p className={`agent-name an-font-27`}>
                          {listgenUserFirstName} {listgenUserLastName}
                        </p>
                      </div>
                      <div className="agent-and-phone mt-8">
                        <div
                          className={`agent-phone ${
                            smallerNameAndPhoneFont
                              ? "smaller-name-and-phone"
                              : ""
                          } `}
                        >
                          {phoneCircleDivider(mobilePhoneNo, fullName.length)}
                        </div>
                      </div>
                      <div
                        className={`designation-and-dre ${designationRowStyles}`}
                      >
                        <p
                          className={`agent-designation ${
                            smallerAgentDesignation
                              ? "smaller-agent-designation"
                              : ""
                          } ${getDesignationStyle(agentDesignation)}`}
                        >
                          {formatAgentDesignation(agentDesignation)}
                        </p>

                        <p className="dre-word">DRE</p>
                        <p className="dre-num"> # {agentLicenseNumber}</p>
                      </div>
                    </div>
                  ) : (
                    <div className="agent-info-col">
                      <div className="agent-and-phone">
                        {listgenUserID === "102843" ? (
                          <p
                            className={`agent-name ${
                              smallerNameAndPhoneFont
                                ? "smaller-name-and-phone"
                                : ""
                            } `}
                          >
                            Galli Team
                          </p>
                        ) : listgenUserID === "102548" ? (
                          <p></p>
                        ) : (
                          <p
                            className={`agent-name ${
                              smallerNameAndPhoneFont
                                ? "smaller-name-and-phone"
                                : ""
                            } ${agentNameStyles}`}
                          >
                            {listgenUserFirstName}{" "}
                            {listgenUserID === "105189"
                              ? `${listgenUserLastName}, MBA`
                              : listgenUserID !== "104835"
                                ? listgenUserLastName
                                : ""}
                          </p>
                        )}
                        {listgenUserID !== "102548" && (
                          <div className="vertical-divider" />
                        )}

                        {!isJeanMarie &&
                          listgenUserID !== "105189" &&
                          listgenUserID !== "109796" && (
                            <div
                              className={`agent-phone ${
                                smallerNameAndPhoneFont
                                  ? "smaller-name-and-phone"
                                  : ""
                              } `}
                            >
                              {phoneCircleDivider(
                                mobilePhoneNo,
                                fullName.length,
                              )}
                            </div>
                          )}
                      </div>
                      {(listgenUserID === "105189" ||
                        listgenUserID === "109796") && (
                        <div className="agent-and-phone">
                          <div className={`agent-phone gummow-name-and-phone`}>
                            {phoneCircleDivider(mobilePhoneNo, fullName.length)}
                          </div>
                        </div>
                      )}

                      {isJeanMarie && (
                        <div className="agent-and-phone">
                          <div
                            className={`agent-phone ${
                              smallerNameAndPhoneFont
                                ? "smaller-name-and-phone"
                                : ""
                            } `}
                          >
                            {phoneCircleDivider(mobilePhoneNo, 1)}
                          </div>
                        </div>
                      )}
                      {listgenUserID === "109982" && (
                        <div className="julie-w-extra-designation-text">
                          Dreams Delivered.
                        </div>
                      )}
                      {isWendyMarioni || listgenUserID === "105100" ? (
                        <div className="designation-and-dre designation-col">
                          <div className="designation-full-row">
                            <p
                              className={`agent-designation ${
                                smallerAgentDesignation
                                  ? "smaller-agent-designation"
                                  : ""
                              } `}
                            >
                              {formatAgentDesignation(agentDesignation)}
                            </p>
                          </div>

                          <div className="designation-full-row">
                            <p className="dre-word">DRE</p>
                            <p className="dre-num"> # {agentLicenseNumber}</p>
                          </div>
                        </div>
                      ) : xsAgentDesignation ? (
                        <div
                          className={`designation-and-dre ${
                            xsAgentDesignation && "column-designation-dre"
                          }`}
                        >
                          <p
                            className={`agent-designation ${
                              smallerAgentDesignation
                                ? "smaller-agent-designation"
                                : ""
                            } ${xsAgentDesignation && "xs-agent-designation"} `}
                          >
                            {formatAgentDesignation(agentDesignation)}
                          </p>
                          <div className="dre-row">
                            <p className="dre-word">DRE</p>
                            <p className="dre-num"> # {agentLicenseNumber}</p>
                          </div>
                        </div>
                      ) : listgenUserID === "102843" ? (
                        <div className="designation-and-dre">
                          <p
                            className={`agent-designation ${
                              smallerAgentDesignation
                                ? "smaller-agent-designation"
                                : ""
                            }`}
                          >
                            {formatAgentDesignation(agentDesignation)}
                          </p>
                          <p className="name-before-dre">Michael Galli</p>
                          <p className="dre-word">DRE</p>
                          <p className="dre-num"> # {agentLicenseNumber}</p>
                        </div>
                      ) : listgenUserID === "112368" ? (
                        <div className="designation-and-dre designation-col">
                          <div className="designation-full-row">
                            <p
                              className={`agent-designation ${
                                smallerAgentDesignation
                                  ? "smaller-agent-designation"
                                  : ""
                              } `}
                            >
                              {formatAgentDesignation(agentDesignation)}
                            </p>
                            <p className="dre-word">DRE</p>
                            <p className="dre-num"> # {agentLicenseNumber}</p>
                          </div>
                          <div className="designation-full-row">
                            <p className="agent-designation smaller-agent-designation capitalized-agent-designation">
                              Certified Probate and Trust Specialist
                            </p>
                          </div>

                          <div className="designation-full-row">
                            <p className="agent-designation smaller-agent-designation capitalized-agent-designation">
                              Certified Luxury Home Marketing Specialist
                            </p>
                          </div>

                          <div className="designation-full-row">
                            <p className="agent-designation smaller-agent-designation capitalized-agent-designation">
                              Accredited Better Business Bureau
                            </p>
                          </div>

                          <div className="designation-full-row">
                            <p className="agent-designation smaller-agent-designation capitalized-agent-designation agent-designation-mb-10">
                              Certified Relocation Professional
                            </p>
                          </div>
                        </div>
                      ) : isSophieTsang ? (
                        <div className="designation-and-dre designation-col">
                          <div className="designation-full-row">
                            <p className="agent-designation smaller-agent-designation capitalized-agent-designation">
                              MBA, Stanford GSB, Certified Residential
                              Specialist
                            </p>
                          </div>

                          <div className="designation-full-row">
                            <p className="agent-designation smaller-agent-designation capitalized-agent-designation">
                              Certified Senior Advisor®
                            </p>
                          </div>

                          <div className="designation-full-row">
                            <p className="agent-designation smaller-agent-designation capitalized-agent-designation agent-designation-mb-10">
                              WSJ RealTrends Verified Top Agent 2018-2025
                            </p>
                          </div>
                          <div className="designation-full-row">
                            <p
                              className={`agent-designation ${
                                smallerAgentDesignation
                                  ? "smaller-agent-designation"
                                  : ""
                              } `}
                            >
                              {formatAgentDesignation(agentDesignation)}
                            </p>
                            <p className="dre-word">DRE</p>
                            <p className="dre-num"> # {agentLicenseNumber}</p>
                          </div>
                          <div className="sophie-tsang-cover-logo-container">
                            <img
                              className="sophie-shield-logo"
                              alt="Sophie Tsang Shield Logo"
                              src="https://d2onbxnrte2nim.cloudfront.net/040226_SophieTsang_crs_shield.png"
                            />

                            <img
                              className="sophie-tsang-csa-logo"
                              alt="Sophie Tsang CSA Logo"
                              src="https://d2onbxnrte2nim.cloudfront.net/non-covers/SophieTsang_CSA-White-Gold-Logo.png"
                            />
                            <div className="sophie-compass-plus-compass-col">
                              <img
                                className="sophie-compass-plus-logo"
                                alt="Sophie Tsang Compass Plus Logo"
                                src="https://d2onbxnrte2nim.cloudfront.net/non-covers/White_CompassPLUS-Logo_500px.png"
                              />
                              <img
                                className={`${slicedLogo} ${
                                  isMemberOfTeam && "team-logo"
                                } ${specialLogoStyles} sophie-compass-brokerage-logo`}
                                src={
                                  specialBrokerageLogoURL
                                    ? specialBrokerageLogoURL
                                    : defaultLogo
                                }
                                alt={specialBrokerageLogoURL}
                              />
                            </div>
                          </div>
                        </div>
                      ) : listgenUserID === "102809" ? (
                        <div className="designation-and-dre designation-col no-mt">
                          <div className="designation-and-dre">
                            <p
                              className={`agent-designation ${
                                smallerAgentDesignation
                                  ? "smaller-agent-designation"
                                  : ""
                              }`}
                            >
                              {formatAgentDesignation(agentDesignation)}
                            </p>

                            <p className="dre-word">DRE</p>
                            <p className="dre-num"> # {agentLicenseNumber}</p>
                          </div>

                          <div className="designation-full-row">
                            <p className="agent-designation smaller-agent-designation capitalized-agent-designation">
                              Real Trends list 2025 Top 1.5%
                            </p>
                          </div>
                        </div>
                      ) : longDesignation ? (
                        <div className="designation-and-dre designation-col">
                          <p
                            className={`agent-designation ${
                              smallerAgentDesignation
                                ? "smaller-agent-designation"
                                : ""
                            } ${getDesignationStyle(
                              agentDesignation,
                            )} designation-full-row`}
                          >
                            {formatAgentDesignation(agentDesignation)}
                          </p>
                          <div className="dre-row mt-5">
                            <p className="dre-word">DRE</p>
                            <p className="dre-num"> # {agentLicenseNumber}</p>
                          </div>
                        </div>
                      ) : (
                        <div
                          className={`designation-and-dre ${designationRowStyles}`}
                        >
                          <p
                            className={`agent-designation ${
                              smallerAgentDesignation
                                ? "smaller-agent-designation"
                                : ""
                            } ${getDesignationStyle(agentDesignation)}`}
                          >
                            {formatAgentDesignation(agentDesignation)}
                          </p>

                          <p className="dre-word">DRE</p>
                          <p className="dre-num"> # {agentLicenseNumber}</p>
                        </div>
                      )}
                      {addEmailUnderDesignation && (
                        <div className="email-under-designation">
                          <p className="email-text">{emailAddress}</p>
                        </div>
                      )}
                      {addWebsiteUnderDesignation && (
                        <div className="website-under-designation">
                          <p className="website-text">{websiteURL}</p>
                        </div>
                      )}
                      {isKarteek && (
                        <div className="extra-cover-footer-full-line-text-container extra-cover-column">
                          <p className="extra-cover-footer-text">
                            The707home.com
                          </p>
                        </div>
                      )}

                      {isLisaCochran && (
                        <div className="extra-cover-footer-full-line-text-container extra-cover-column">
                          <p className="extra-cover-footer-text">
                            REALTOR® for 35 Years | Certified Senior Advisor
                            (CSA)® | SRES®
                          </p>

                          <p className="extra-cover-footer-text">
                            Certified Trust & Probate Specialist | Five Star
                            Professional Award 2012-2026
                          </p>
                        </div>
                      )}
                      {isLeeShantePappas && (
                        <div className="extra-cover-footer-text-container">
                          <p className="extra-cover-footer-text">
                            Market Experts, Personal Touch. We're Just a Call
                            Away.
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                  <div
                    className={`agent-info-box-logo ${
                      brokerageName.includes("Keller Williams") &&
                      "longer-agent-info-box-logo"
                    } ${
                      (isKatherineHunt ||
                        isKellyMahan ||
                        isStephanieSills ||
                        isMicheleManzone ||
                        isFlashberger ||
                        isGigi ||
                        isLisaMcCollum ||
                        isJessieSessions ||
                        isCammieC ||
                        isSamanthaC ||
                        isAnnAlbanese ||
                        isDawnThomas ||
                        listgenUserID === "101567" ||
                        mlsAreaID === "SCL-16N" ||
                        mlsAreaID === "SCL-16A" ||
                        isTaylorK) &&
                      "agent-logo-mr"
                    } ${agentInfoBoxStyles}`}
                  >
                    {(listgenUserID === "109705" ||
                      listgenUserID === "116930") && (
                      <div className="kurt-piper-white-logo">
                        <img
                          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/kurt-piper-logo-november-.png"
                          alt="Kurt Piper White Logo"
                          className="kurt-piper-white-logo-img"
                        />
                      </div>
                    )}
                    {listgenUserID === "102567" ? (
                      <div className="sophie-tsang-cover-map-container">
                        <img
                          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/for-listgen-map-min.png"
                          className="sophie-tsang-cover-map"
                          alt="Sophie Tsang Cover Map"
                        />
                      </div>
                    ) : listgenUserID === "106031" ? null : isDemo ? (
                      <img
                        className={`${demoSlicedLogo} ${
                          isMemberOfTeam && "team-logo"
                        }`}
                        src={shortDemoURL}
                        alt={`${brokerageName} logo`}
                      />
                    ) : listgenUserID === "113013" ? (
                      <div className="leslie-manzone-cover-info-logo-container">
                        <img
                          className={`${slicedLogo} ${
                            isMemberOfTeam && "team-logo"
                          } ${specialLogoStyles}`}
                          src={
                            specialBrokerageLogoURL
                              ? specialBrokerageLogoURL
                              : defaultLogo
                          }
                          alt={specialBrokerageLogoURL}
                        />
                        <div className="leslie-manzone-logo">
                          <img
                            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/030626_LeslieManzone_logoFrontCover.jpg"
                            alt="agent-logo"
                          />
                        </div>
                      </div>
                    ) : listgenUserID === "107269" ||
                      listgenUserID === "116936" ||
                      listgenUserID === "107230" ? (
                      <div className="lori-olson-cover-info-logo-container">
                        <div className="lori-olson-mcguire-olson-logo">
                          <img
                            src="https://d2onbxnrte2nim.cloudfront.net/non-covers/111325_McGuireOlson_Logo_No-ICON_500px.png"
                            alt="agent-logo"
                          />
                        </div>

                        <img
                          className={`${slicedLogo} ${
                            isMemberOfTeam && "team-logo"
                          } ${specialLogoStyles}`}
                          src={
                            specialBrokerageLogoURL
                              ? specialBrokerageLogoURL
                              : defaultLogo
                          }
                          alt={specialBrokerageLogoURL}
                        />
                      </div>
                    ) : isTeresaM ? (
                      <div className="teresa-m-cover-logo-container">
                        <img
                          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/050826_TeresaMarlow_WhiteTranspt_logo.png"
                          alt="Teresa M Logo"
                          className="teresa-m-cover-logo"
                        />
                      </div>
                    ) : specialBrokerageLogoURL ? (
                      <img
                        className={`${slicedLogo} ${
                          isMemberOfTeam && "team-logo"
                        } ${specialLogoStyles}`}
                        src={
                          specialBrokerageLogoURL
                            ? specialBrokerageLogoURL
                            : defaultLogo
                        }
                        alt={specialBrokerageLogoURL}
                      />
                    ) : (
                      ""
                    )}
                    {listgenUserID === "105189" && (
                      <div className="michael-noh-cover-photo-headshot">
                        <img
                          src="https://d2onbxnrte2nim.cloudfront.net/CompassLosAltos_HS_4.20.23.020+Square+Profile_zoomed_white+background.jpg"
                          alt="Michael Noh Headshot"
                        />
                      </div>
                    )}

                    {listgenUserID === "104804" && (
                      <div className="julie-baumann-cover-photo-headshot">
                        <img
                          src="https://d2onbxnrte2nim.cloudfront.net/071225_Julie_squared.jpg"
                          alt="Julie Baumann Headshot"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          {listgenUserID === "113597" && (
            <div className="alison-c-napa-lux-logo">
              <img src="https://d2onbxnrte2nim.cloudfront.net/non-covers/030626_AlisonChristianson_logoWHITE.png" />
            </div>
          )}
          {(listgenUserID === "116936" || listgenUserID === "107230") && (
            <div className="lori-olson-mcguire-olson-banner">
              <img
                src="https://d2onbxnrte2nim.cloudfront.net/non-covers/MORETeam_BlackStatsBanner_080426.png"
                alt="agent-logo"
              />
            </div>
          )}
        </div>
      );
    }
  }
}

export default QVFourCoverPageInfo;
